import { FC } from 'react';
import {
  UserNote,
  UserNotesByObjective,
  UserNotesByLesson,
  UserNotesResponse,
} from '@teachur/http-client';
import { EmptyState } from '@new/common/ui/EmptyState/EmptyState';
import { NoteItem } from '../NoteItem/NoteItem';
import { NoteGroup } from '../NoteGroup/NoteGroup';

type NotesRel = 'objective' | 'lesson' | 'course';

interface NotesListProps {
  data: UserNotesResponse | undefined;
  rel: NotesRel;
}

export const NotesList: FC<NotesListProps> = ({ data, rel }) => {
  if (!data) return null;

  if (rel === 'lesson' && data.objectives && data.objectives.length > 0) {
    return (
      <>
        {data.objectives.map((o: UserNotesByObjective) => (
          <NoteGroup key={o.id} id={o.id} name={o.name} userNotes={o.userNotes} />
        ))}
      </>
    );
  }

  if (rel === 'course' && data.lessons && data.lessons.length > 0) {
    return (
      <>
        {data.lessons.map((l: UserNotesByLesson) => (
          <NoteGroup key={l.id} id={l.id} name={l.name} userNotes={l.userNotes} />
        ))}
      </>
    );
  }

  if (data.userNotes && data.userNotes.length > 0) {
    return (
      <>
        {data.userNotes.map((note: UserNote) => (
          <NoteItem key={note.id} note={note} />
        ))}
      </>
    );
  }

  return <EmptyState message="No notes yet." />;
};
